import React, { useEffect, useState } from 'react'
import { LoadingCard, MsgSemRegistros, ApexCharts } from '../../../../Components'
import { Card, CardBody, Col } from 'reactstrap'
import { LogAcessoGetAcessosPorDia } from '../../../../Service/ApiService'
import { normaliseValue } from '../../../../helpers/util'
import { BoxTitle, LblTitle, LblTotal, MainTotal, ValueTotal } from './styles.js'

let initChart = {
  series: [{ name: 'Acessos', data: [] }],
  options: {
    chart: { type: 'bar', height: 320, toolbar: { show: false } },
    xaxis: { categories: [] },
    responsive: [{ breakpoint: 450, options: { chart: { width: 350 }, legend: { position: 'bottom' } } }],
  },
}

let totalAccess = 0

const AccessByDayChart = ({ filters }) => {
  const [confChart, setConfChart] = useState(initChart)
  const [msgId, setMsgId] = useState(1)

  async function loadData() {
    setMsgId(1)
    try {
      const response = await LogAcessoGetAcessosPorDia(filters)
      if (response?.length > 0) {
        const seriesData = response.map((item) => item.qtdeDia)
        totalAccess = seriesData.reduce((acumulador, valorAtual) => acumulador + valorAtual, 0)
        let _confChart = { ...initChart }
        _confChart.series = [{ name: 'Acessos', data: seriesData }]
        _confChart.options.xaxis.categories = response.map((item) => item.dia)

        setConfChart(_confChart)
        setMsgId(2)
      } else {
        setMsgId(3)
        totalAccess = 0
      }
    } catch {
      setMsgId(3)
      totalAccess = 0
    }
  }

  useEffect(() => {
    if (filters) loadData()
  }, [filters])

  return (
    <Card className="main-card mb-2">
      <CardBody>
        <BoxTitle>
          <LblTitle>Acessos por dia</LblTitle>
          {/* <ItemTitle destaque={true}>Total: {normaliseValue(totalAccess, 0)}</ItemTitle> */}
          <MainTotal>
            <ValueTotal>{normaliseValue(totalAccess, 0)}</ValueTotal>
            <LblTotal>Total de acessos</LblTotal>
          </MainTotal>
        </BoxTitle>
        {
          {
            1: (
              <Col md="12" className="text-center">
                <LoadingCard isVisible={true} />
              </Col>
            ),
            2: <ApexCharts options={confChart.options} series={confChart.series} type="bar" height={295} />,
            3: <MsgSemRegistros />,
          }[msgId]
        }
      </CardBody>
    </Card>
  )
}

export default AccessByDayChart
